import { FontClass } from "@ui/types/enums/FontClass";
import { HeaderText } from "@ui/components/text/HeaderText";
import type { Props } from "@ui/components/text/HeaderText";

export function Header2(props: Omit<Props, "fontClass">) {
  return <HeaderText {...props} fontClass={FontClass.Header2} />;
}
